import { Icon, IconProps } from '@chakra-ui/react'

export const ApprovalIcon = ({ ...props }: IconProps) => {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0_627_3616)">
      <path
        d="M5.33331 21.3333V29.3333H26.6666V21.3333C26.6666 19.8666 25.4666 18.6666 24 18.6666H7.99998C6.53331 18.6666 5.33331 19.8666 5.33331 21.3333ZM24 24H7.99998V21.3333H24V24ZM16 2.66663C12.32 2.66663 9.33331 5.65329 9.33331 9.33329L16 18.6666L22.6666 9.33329C22.6666 5.65329 19.68 2.66663 16 2.66663ZM16 14.6666L12 9.33329C12 7.11996 13.7866 5.33329 16 5.33329C18.2133 5.33329 20 7.11996 20 9.33329L16 14.6666Z"
        fill="currentColor"
      />
      </g>
      <defs>
      <clipPath id="clip0_627_3616">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
    </Icon>
  )
}
